export const ParameterConstants = {
  parameterFieldName: 'parameterValue',
};
